import { render, staticRenderFns } from "./UserAddressList.vue?vue&type=template&id=db0cf754&scoped=true"
import script from "./UserAddressList.vue?vue&type=script&lang=js"
export * from "./UserAddressList.vue?vue&type=script&lang=js"
import style0 from "./UserAddressList.vue?vue&type=style&index=0&id=db0cf754&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db0cf754",
  null
  
)

export default component.exports